import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Fonts self-hostees via @fontsource (aucun CDN Google au runtime).
//
// Le sous-ensemble « latin » ne contient ni le ł polonais, ni le ş turc, ni une
// seule lettre cyrillique : sans les sous-ensembles ci-dessous, un mot polonais
// s'affichait moitie en Inter, moitie en police systeme, ce qui se voit
// immediatement. Chaque face porte sa `unicode-range`, donc le navigateur ne
// telecharge un fichier que s'il rencontre un glyphe qui s'y trouve : un joueur
// francais ne paie rien pour les huit autres langues.
//
// COMPROMIS: Fraunces n'existe pas en cyrillique chez @fontsource. Les titres
// russes tombent donc sur la serif systeme. Le repli est integral (Fraunces n'a
// aucun glyphe cyrillique), la chaine reste donc homogene : c'est le defaut
// acceptable, contrairement au panachage a l'interieur d'un mot.
import '@fontsource/fraunces/latin-400.css';
import '@fontsource/fraunces/latin-600.css';
import '@fontsource/fraunces/latin-ext-400.css';
import '@fontsource/fraunces/latin-ext-600.css';
import '@fontsource/fraunces/vietnamese-400.css';
import '@fontsource/fraunces/vietnamese-600.css';
import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/inter/latin-ext-400.css';
import '@fontsource/inter/latin-ext-600.css';
import '@fontsource/inter/cyrillic-400.css';
import '@fontsource/inter/cyrillic-600.css';
// Le vietnamien empile ses diacritiques (ệ, ữ, ị) : sans ce sous-ensemble,
// chaque mot accentue tombait sur la police systeme, au milieu d'une phrase
// rendue en Inter.
import '@fontsource/inter/vietnamese-400.css';
import '@fontsource/inter/vietnamese-600.css';
import '@fontsource/jetbrains-mono/latin-500.css';

import './styles/tokens.css';
import './styles/screens.css';
import './styles/gallery.css';
import './styles/shell.css';
import { App } from './App.js';


const container = document.getElementById('root');
if (container === null) throw new Error('#root introuvable dans index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
